import { Component, OnInit, signal } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { trim } from 'lodash';
import { Observable, first, map, tap } from 'rxjs';
import { SignService } from '@libs/app.services/sign/sign.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { CodeInputComponent } from '../code-input/code-input';
import { PhoneNumberPipe } from '@libs/pipes/sign/phone-number.pipe';
import { SubmitSpinnerComponent } from '@libs/stand-alone-components/commons/submit-spinner/submit-spinner';
@Component({
  selector: 'app-sign-code',
  templateUrl: './code.component.html',
  styleUrl: './code.component.scss',

  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    CodeInputComponent,
    SubmitSpinnerComponent,
    PhoneNumberPipe,
  ],
})
export class CodeComponent implements OnInit {
  showWarning$: Observable<string>;
  codeForm = signal<FormGroup>(null);
  value$: Observable<string> = this.activatedRoute.queryParams.pipe(
    map(params => params['value']),
    tap(value => (/\S+@\S+\.\S+/.test(value) ? this.email.set(value) : this.phone.set(value))),
    tap(value => !value && this.router.navigate(['', 'sign', 'in'])),
  );
  loading = signal(false);
  email = signal('');
  phone = signal('');
  constructor(
    private formBuilder: FormBuilder,
    private sign: SignService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
  ) {}
  ngOnInit(): void {
    this.codeForm.set(
      this.formBuilder.group({
        code: ['', Validators.compose([Validators.required, Validators.minLength(3), Validators.maxLength(10)])],
      }),
    );
  }
  submitCode(value: string) {
    this.loading.set(true);
    const code = trim(this.codeForm().value.code).toLocaleLowerCase();
    this.showWarning$ = this.sign.checkCode(value, code).pipe(
      tap(() => this.codeForm().controls['code'].setValue('')),
      tap(() => this.loading.set(false)),
      map(res => (res?.error ? `ERRORS.CODE_NOT_CORRECT` : '')),
      first(),
    );
  }
}
